<template>
  <div>
    <template
      v-if="
        this.$store.state.nameTheme == 'MR' || this.$store.state.theme == 'mr'
      "
    >
      <svg
        width="45"
        height="45"
        viewBox="0 0 34 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1215_27844)">
          <path
            d="M17.4485 0.0108412C16.8306 -0.0156114 16.3762 0.0108412 16.1285 0.0108412C13.438 0.0541272 0 2.49738 0 16.6952C0 27.0766 10.0839 37.4461 14.9311 42.4336C15.388 42.9049 15.8063 43.3306 16.1646 43.7105C16.3377 43.8933 16.583 43.9991 16.8306 43.9991C17.0783 43.9991 17.3283 43.8957 17.4966 43.7105C17.8549 43.3306 18.2708 42.9049 18.7301 42.4336C23.5773 37.4509 33.6612 27.0815 33.6612 16.7C33.666 2.49738 20.329 0.0661511 17.6313 0.0228651L17.4485 0.0108412Z"
            fill="#96154A"
          />
          <g clip-path="url(#clip1_1215_27844)">
            <path
              d="M9.36501 13.9821H7.23474V23.5275H9.36501V13.9821Z"
              fill="white"
            />
            <path
              d="M26.4192 13.9821H24.289V23.5275H26.4192V13.9821Z"
              fill="white"
            />
            <path
              d="M29.3201 23.5251H4.34109V25.6553H29.3201V23.5251Z"
              fill="white"
            />
            <path
              d="M15.537 17.7859H12.3344V21.5966H15.537V17.7859Z"
              fill="white"
            />
            <path
              d="M21.3219 17.7859H18.1193V19.707H21.3219V17.7859Z"
              fill="white"
            />
            <path
              d="M25.7869 8.59631H7.87432L6.59038 10.5174L5.65749 11.8927V12.2341C5.65749 14.2298 7.28284 15.8551 9.27847 15.8551C10.2546 15.8551 11.1419 15.4656 11.7958 14.8333C12.4474 15.4656 13.3346 15.8551 14.3132 15.8551C15.2918 15.8551 16.179 15.4656 16.8306 14.8333C17.4822 15.4656 18.3694 15.8551 19.348 15.8551C20.3266 15.8551 21.2138 15.4656 21.8654 14.8333C21.9736 14.939 22.0914 15.0328 22.2116 15.1242C22.8175 15.581 23.5652 15.8551 24.3803 15.8551C26.3736 15.8551 27.9989 14.2298 27.9989 12.2341V11.8927L27.0684 10.5174L25.7869 8.59631ZM9.28087 13.6719C8.58841 13.6719 8.00896 13.1766 7.87432 12.5202L9.23279 10.5174H10.6946V12.2341C10.6946 12.3039 10.697 12.3712 10.7019 12.4385C10.6033 13.1358 9.97333 13.6719 9.28087 13.6719ZM14.3132 13.6719C13.5919 13.6719 12.9908 13.1334 12.8922 12.4385C12.8995 12.3712 12.8995 12.3039 12.8995 12.2341L12.8874 10.5174H15.727V12.2341C15.727 12.3039 15.7294 12.3712 15.7318 12.4385C15.6356 13.1358 15.0345 13.6719 14.3132 13.6719ZM19.348 13.6719C18.6267 13.6719 18.0256 13.1334 17.927 12.4385C17.9342 12.3712 17.9342 12.3039 17.9342 12.2365L17.9222 10.5174H20.7714L20.7617 12.2365C20.7617 12.3063 20.7642 12.3736 20.7666 12.4433C20.6704 13.1358 20.0693 13.6719 19.348 13.6719ZM25.7869 12.5202C25.6522 13.1766 25.1016 13.6719 24.3803 13.6719C23.659 13.6719 23.0579 13.1334 22.9593 12.4385C22.9666 12.3712 22.9666 12.3039 22.9666 12.2341L22.9617 10.5174H24.4308L25.7869 12.5202Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1215_27844">
            <rect width="33.6612" height="44" fill="white" />
          </clipPath>
          <clipPath id="clip1_1215_27844">
            <rect
              width="27.6791"
              height="17.0566"
              fill="white"
              transform="translate(2.99103 8.59625)"
            />
          </clipPath>
        </defs>
      </svg>
    </template>

    <template
      v-if="
        this.$store.state.nameTheme == 'inpost' ||
        this.$store.state.theme == 'inpost'
      "
    >
      <svg
        width="30"
        height="40"
        viewBox="0 0 140 183"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_73_771)">
          <path
            d="M72.57 0.0449909C70 -0.0650277 68.11 0.0449909 67.08 0.0449909C55.89 0.225022 0 10.3867 0 69.4368C0 112.614 41.94 155.741 62.1 176.485C64 178.445 65.74 180.216 67.23 181.796C67.95 182.556 68.97 182.996 70 182.996C71.03 182.996 72.07 182.566 72.77 181.796C74.26 180.216 75.99 178.445 77.9 176.485C98.06 155.761 140 112.634 140 69.4568C140.02 10.3867 84.55 0.27503 73.33 0.0949994L72.57 0.0449909Z"
            fill="#FFCC05"
          />
          <path
            d="M0.0599976 72.0648C1.74144 114.378 42.3963 156.201 62.1532 176.547C64.0548 178.509 65.7963 180.281 67.2876 181.863C68.0082 182.624 69.0291 183.065 70.06 183.065C71.0909 183.065 72.1318 182.634 72.8324 181.863C74.3236 180.281 76.0551 178.509 77.9668 176.547C97.7337 156.221 138.399 114.398 140.06 72.0648H0.0599976Z"
            fill="#1D1D1D"
          />
          <path
            d="M65.81 56.2723H52.47V72.1558H65.81V56.2723Z"
            fill="#1D1D1D"
          />
          <path d="M89.9 56.2723H76.56V64.2741H89.9V56.2723Z" fill="#1D1D1D" />
          <path
            d="M113.84 29.9465L108.5 21.9448H33.89L28.54 29.9465L24.65 35.6778V37.0981C24.65 42.2592 27.26 46.8202 31.22 49.5408V72.1458H40.09V52.1714C44.01 52.0814 47.57 50.491 50.21 47.9305C52.92 50.561 56.62 52.1914 60.7 52.1914C64.78 52.1914 68.47 50.571 71.19 47.9305C73.9 50.561 77.6 52.1914 81.68 52.1914C85.76 52.1914 89.45 50.571 92.17 47.9305C92.62 48.3706 93.11 48.7607 93.61 49.1407C96.04 50.9711 99.02 52.0914 102.26 52.1714V72.1458H111.13V49.5508C115.1 46.8302 117.71 42.2592 117.71 37.0981V35.6778L113.83 29.9465H113.84ZM39.75 43.0994C36.87 43.0994 34.45 41.039 33.89 38.2984L39.55 29.9565H45.64V37.1081C45.64 37.3982 45.64 37.6782 45.67 37.9583C45.26 40.8589 42.64 43.0994 39.75 43.0994ZM60.71 43.0994C57.71 43.0994 55.2 40.8589 54.79 37.9583C54.82 37.6782 54.82 37.3982 54.82 37.1081L54.77 29.9565H66.6V37.1081C66.6 37.3982 66.61 37.6782 66.62 37.9583C66.22 40.8589 63.72 43.0994 60.71 43.0994ZM87.59 37.9783C87.19 40.8589 84.69 43.0994 81.68 43.0994C78.67 43.0994 76.17 40.8589 75.76 37.9583C75.79 37.6782 75.79 37.3982 75.79 37.1181L75.74 29.9565H87.61L87.57 37.1181C87.57 37.4082 87.58 37.6882 87.59 37.9783ZM96.72 37.9583C96.75 37.6782 96.75 37.3982 96.75 37.1081L96.73 29.9565H102.85L108.5 38.2984C107.94 41.029 105.65 43.0994 102.64 43.0994C99.63 43.0994 97.13 40.8589 96.72 37.9583Z"
            fill="#1D1D1D"
          />
          <path
            d="M58.005 120.598C54.8676 118.919 51.3661 118.041 47.8098 118.041C44.2536 118.041 40.7521 118.919 37.6147 120.598C40.7503 122.283 44.2525 123.165 47.8098 123.165C51.3672 123.165 54.8693 122.283 58.005 120.598Z"
            fill="#FFCC05"
          />
          <path
            d="M61.9826 104.628C60.0021 101.682 57.3294 99.2706 54.2 97.6056C51.0706 95.9406 47.5808 95.0734 44.0383 95.0805C46.0163 98.0286 48.6886 100.442 51.8185 102.107C54.9485 103.773 58.4395 104.639 61.9826 104.628Z"
            fill="#FFCC05"
          />
          <path
            d="M73.0801 92.3921C72.7349 88.873 71.5174 85.4964 69.5385 82.5699C67.5554 79.6196 64.8712 77.2108 61.728 75.5608C62.0734 79.0923 63.2904 82.482 65.269 85.4238C67.2476 88.3656 69.9256 90.7669 73.0612 92.411"
            fill="#FFCC05"
          />
          <path
            d="M61.9826 136.557C60.0021 139.503 57.3294 141.915 54.2 143.58C51.0706 145.245 47.5808 146.112 44.0383 146.105C46.0163 143.157 48.6886 140.743 51.8185 139.078C54.9485 137.413 58.4395 136.547 61.9826 136.557Z"
            fill="#FFCC05"
          />
          <path
            d="M73.0801 148.804C72.7426 152.343 71.5248 155.739 69.5385 158.683C67.553 161.634 64.8695 164.045 61.728 165.702C62.0642 162.161 63.277 158.761 65.2562 155.81C67.2354 152.86 69.9183 150.451 73.0612 148.804"
            fill="#FFCC05"
          />
          <path
            d="M75.5092 129.321C77.9145 129.082 80.2289 128.274 82.2619 126.963C65.961 122.729 79.1831 97.8751 90.4785 92.8646C73.2048 94.2759 64.516 107.375 64.4593 120.456C64.4027 133.536 73.082 146.891 90.5352 148.198C83.2489 144.098 77.8546 137.297 75.5092 129.255"
            fill="#FFCC05"
          />
        </g>
        <defs>
          <clipPath id="clip0_73_771">
            <rect width="140" height="183" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </template>
  </div>
</template>

<script>
export default {};
</script>
